<template>
  <div>
    
    <check-box
      v-for="item in items"
      :key="item.name"

      :boldLabels="boldLabels"
      :customFontSize="customFontSize"
      @select="boxSelect"
      :active="activeBoxes"
      class="box-item"
      :label="item.label"
      :value="item.value"
      :name="item.name" />

  </div>
</template>

<script>
import CheckBox from '@/components/standard/form/customItems/CheckBox'
import Vue from 'vue'

export default {
  methods: {
    boxSelect (e) {
      let removed = e.value

      this.$emit('fieldUpdate', {
        changed: {
          name: e.name,
          value: e.value,
          removed
        }
      })
    }
  },

  props: {
    customFontSize: {
      type: String,
      required: false,
      default: '12px'
    },
    boldLabels: {
      type: Boolean,
      required: false,
      default: false
    },
    activeBoxes: {
      type: Object,
      required: false,
      default: () => {return {}}
    },
    default: {
      type: Object,
      required: false,
      default: null
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  components: {
    'check-box': CheckBox
  }

}
</script>

<style scoped>
.radio-item {
  display: inline-block;
  margin-right: 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/standard/form/FormCheckbox.vue?1e3c7b0c